import { render } from "./GuildAuthenticated.vue?vue&type=template&id=2d5d7234"
import script from "./GuildAuthenticated.vue?vue&type=script&lang=js"
export * from "./GuildAuthenticated.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bewinxed/Downloads/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__